export default "__VITE_ASSET__9d50f9ed__"